module.exports = __webpack_public_path__ + "static/media/Rejected.6d7e3427.svg";